var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'margin-top-70': _vm.$route && _vm.$route.name === 'Startseite' },attrs:{"id":"app"}},[(
      (_vm.angemeldeterMitarbeiter && _vm.kategorienLoaded && _vm.permissions) ||
      _vm.loginError
    )?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }